module.exports = __webpack_public_path__ + "img/service-3.b5b1f3f1.svg";